module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "Aut"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "EXL"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("Mother called: “I can’t talk. I’m surrounded by handsome men.” Emergency surgery. If you can hold a thought for her now … ")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("I have covered a lot of wars, and try to be careful about comparing combat to anything else. But wars and final illnesses both have moments of panic spaced between hours of tedium. There can be a lot of waiting and staring off into space.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It was in these times, during what turned out to be the last days of my mother’s life, that I began to post messages on Twitter. I think I wrote these 140-character lines for distraction, for companionship, and because although my world had pretty much shrunk to the confines of a single room in an intensive care unit, what I heard, saw, and felt there touched on the universal experience of life and death (an overworked phrase that’s apt for once).")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My mother was also just so funny and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("interesting")]), _vm._v(". I wanted to share what she said, to make people laugh and think, especially as I began to feel that my mother was giving a last great performance—it certainly was one for our small family. She was also an old showgirl who had been married to a comedian and had a son who is a broadcaster. My mother was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("not")]), _vm._v(" a shrinking violet. She knew she was giving us great material. I don’t believe anything I wrote, then or now, violates her privacy. I hope it reveals, for others to enjoy, my mother’s humor, spirit, wisdom, and the pleasure of her company.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I have left the Tweets unchanged, including whatever typos I thumbed at the time. I have sometimes rearranged where they appear in the timeline of events, as I often did not post a Tweet for hours after whatever prompted it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I am one of those people who really do walk around with a notebook. But when I flew to join her in the hospital, I did not know my mother would die there; in fact, I hoped my arrival might help spring her from the ICU. I did not know I would write this book. I did not take reportorial notes, and often a few scrawled words would represent a conversation of many minutes. I rely on the intensity of those days, a practiced memory, and a son’s love to reconstruct here what my mother said with accuracy and clarity.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I have kept a lot of names, but resorted to just first names in many cases, and changed a few where it seems wise or kind. I have changed the names of all doctors.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All mistakes are mine and mine alone. My mother worked hard to rear a son who can say that.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ef41090","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorsnote.vue
// module id = 72
// module chunks = 0